module.exports = "<div *ngIf=\"displayError\" >\n  <span class=\"glyphicon glyphicon-remove form-control-feedback fix-error-icon\"></span>\n <!--  <span class=\"sr-only\">(error)</span> -->\n  <div class=\"error-msg\">\n    {{ errorMsg }}\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/field-error-display/field-error-display.component.html
// module id = ../../../../../src/app/mnt-master/field-error-display/field-error-display.component.html
// module chunks = main